<!-- <nav class="navbar navbar navbar-expand-md navbar-dark">
  <div class="container-fluid mainScheduleContainer">
    <div class="navbar-brand" [routerLink]="['/dashboard']">
      <span class="header-niit-logo" title="NIIT"><img src="assets/logo.svg" alt="NIIT"></span>
      <span class="tr-logo"><span class="talent">Talent</span><span class="readiness">Readiness</span></span>
    </div>
    <button class="navbar-toggler" type="button" data-backdrop="static" data-keyboard="false" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
      </ul>
      <ul class="navbar-nav">
        <li class="nav-item">
          <div class="headerIcons icon_1" title="Dashboard" [routerLink]="['/dashboard']">
          </div>
        </li>
        <li class="nav-item" *ngIf="superUserType !='super' && superUserType !='admin'">
          <div class="headerIcons icon_2" title="Booking" (click)="gotoNextPage($event, '/planSchedule')">
          </div>
        </li>
        <li class="nav-item" *ngIf="superUserType !='super' && superUserType !='admin'">
          <div class="dropdown viewReportDropDown">
            <div class="customVerticalAlignment headerIcons icon_3" title="View Report" id="dropdownMenuButton"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            </div>
            <div class="dropdown-menu dropdownMenuButton" aria-labelledby="dropdownMenuButton"
              style="left: -39px !important;">
              <a class="dropdown-item " (click)="gotoNextPage($event, '/workload')">Work Load</a>
              <a class="dropdown-item" (click)="gotoNextPage($event, '/resourceBookingReport')">Resource View</a>
              <a class="dropdown-item" (click)="gotoNextPage($event, '/proReport')">Project View</a>
            </div>
          </div>
        </li>
        <li class="nav-item" *ngIf="superUserType !='super' && superUserType !='admin'">
          <div class="headerIcons icon_4 disabled" title="Add User">
          </div>
        </li>
        <li class="nav-item">
          <a _ngcontent-c2="" title="User Profile" class="ff1" id="dropdownMenuProfileButton" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <img [src]="loginImageURL" class="profileIcon" />
            <span class="caret"></span>
          </a>
          <div class="dropdown-menu" id="dropDownPro" aria-labelledby="dropdownMenuProfileButton">
            <a class="dropdown-item cursorLink">Signed in as
              <br />
              <span>{{loginUserName}}</span>
            </a>
            <hr />
            <a class="dropdown-item" (click)="logout()">Sign out</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav> -->

<headerCustom></headerCustom>

<!--Add User Modal Box--> 
<div *ngIf="showHideModel" class="modal fade" id="formDailogContainer" tabindex="-1" role="dialog"
  aria-labelledby="formDailogContainer" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <form [formGroup]="formObj">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Skill Rating Master Form</h5>
          <button type="button" class="close" #closeModel data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <input *ngIf="formObj.value.ratingId" type="hidden" formControlName="ratingId">

        <div class="modal-body">
          <div class="form-group row">
            <label for="ratingName" class="col-sm-4 col-form-label control-label">Rating name</label>
            <div class="col-sm-8">
              <input type="text" [ngClass]="{ 'is-invalid': submitted && f.ratingName.errors }"
                onfocus="this.placeholder = ''" onblur="this.placeholder = 'Rating name'" placeholder="Rating name"
                class="form-control" formControlName="ratingName">
            </div>
          </div>

          <div class="form-group row">
            <label for="score" class="col-sm-4 col-form-label control-label">Score</label>
            <div class="col-sm-8">
              <input type="number" [ngClass]="{ 'is-invalid': submitted && f.score.errors }"
                onfocus="this.placeholder = ''" onblur="this.placeholder = 'Score'" placeholder="Score"
                class="form-control" formControlName="score">
            </div>
          </div>

          <div class="form-group row">
            <label for="score" class="col-sm-4 col-form-label control-label">Remark</label>
            <div class="col-sm-8">
              <input type="text" [ngClass]="{ 'is-invalid': submitted && f.remark.errors }"
                onfocus="this.placeholder = ''" onblur="this.placeholder = 'Remark'" placeholder="Remark"
                class="form-control" formControlName="remark">
            </div>
          </div>

          <!-- <div class="form-group row" *ngIf="common.isSuperUser()">
            <label for="towerDropDown" class="col-sm-4 col-form-label control-label">Tower</label>
            <div class="col-sm-8">
              <select id="towerDropDown" class="form-control" formControlName="towerId">
                <option *ngFor="let tower of allTowers;" value="{{tower.towerId}}">{{ tower.towerName }}</option>
              </select>
            </div>
          </div> -->

        </div>
        <div class="modal-footer">
          <button *ngIf="!formObj.value.ratingId" class="btn hvr-bounce-to-top" (click)="onSubmit(formObj.value)"
            [disabled]="formObj.invalid">Add Skill</button>
          <button *ngIf="formObj.value.ratingId" type="button" class="btn hvr-bounce-to-top"
            (click)="updateSkillRating(formObj.value)">Update Skill</button>
          <button type="button" class="btn hvr-bounce-to-top" data-dismiss="modal" aria-label="Close">Cancel</button>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- <sidebarWrapper></sidebarWrapper> -->

<div class="main-content">
    <div class="adduserContainer">
        <div class="pageContentWrapper">
            <div class="pageHeading">
              <div class="row">
                <div class="headerName col-8">
                  <div class="labelLinks">
                    <nav aria-label="breadcrumb">
                      <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                          <a [routerLink]="['/adminDashboard']">View Admin Dashboard</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Skill Rating Master</li>
                      </ol>
                    </nav>
                  </div>
                </div>
                <div class="col-4 addUserButton">
                  <button type="button" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#formDailogContainer" (click)="initUserInfo()">Add
                    Skill</button>
                </div>
              </div>
            </div>
          <div class="addUserButtonTableData" *ngIf="formInfoList.length >0">
            <div class="addUserFormContainer addUserFormLayout customizeRtsScrollBar">
              <table datatable="ng" class=" table table-striped lh-23 rsTable userRcCustomTable customizeRtsScrollBar">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Score</th>
                    <th>Rating Name</th>
                    <th>Remark</th>
                    <!-- <th *ngIf="common.isSuperUser()">Tower</th> -->
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr *ngFor="let formInfo of formInfoList; let i = index;">
                    <td>
                      <div>{{formInfoList.indexOf(formInfo) + 1}}</div>
                    </td>
                    <td>
                      <div>{{formInfo.score}}</div>
                    </td>
                    <td>
                      <div>{{formInfo.ratingName}}</div>
                    </td>
      
                    <td>
                      <div>{{formInfo.remark}}</div>
                    </td>
      
                    <!-- <td *ngIf="common.isSuperUser()">
                      <div>{{formInfo.towerName}}</div>
                    </td> -->
      
                    <td class="addUserButtons">
                      <button class="btn form-group hvr-bounce-to-top" data-backdrop="static" data-keyboard="false" title="Edit" type="button" data-toggle="modal"
                        data-target="#formDailogContainer" (click)="setUpdateUserInfo(formInfo)">
                        <img src="assets/edit.svg" />
                      </button>
                      <!-- <button class="btn form-group hvr-bounce-to-top" title="Delete" type="button"
                        (click)="onDeleteSubmit(formInfo)">
                        <img src="assets/delete.svg" />
                      </button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      
</div>

<div class="loader" *ngIf="loading">
    <div class="lds-roller">
        <!-- <img src="assets/preloader.gif" />
        <span>Wait...</span> -->
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>